import { useCallback, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSportsSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { useColorScheme } from '@namespace/themes';
import { SPORT_IDS } from '../../../../../constants';
import { useGetPathParams } from '../../../../../hooks/useGetPathParams';
import { useEventField } from '../../../../../store';
import { PandascoreBlock } from '../../constants';
import { getLocaleFromLangForPandascore } from '../../utils';

const usePandascore = (src: string) => {
  const { language } = useI18n();
  const { eventId } = useGetPathParams();
  const { isDarkModeEnabled } = useColorScheme();
  const { pandascoreUserName, isShowPandascoreTabs } = useSportsSettings();
  const [search, setSearch] = useSearchParams();
  const categoryId = useEventField(eventId, 'categoryId');
  const isShowTabs = isShowPandascoreTabs && Boolean(eventId);
  const selectedTab = search.get('tab') || PandascoreBlock.GENERAL_STATS;

  const urlObjectRef = useRef(new URL(src, window.location.origin));

  urlObjectRef.current.searchParams.set(
    'lang',
    getLocaleFromLangForPandascore(language)
  );

  if (!isDarkModeEnabled) {
    // TODO it's a temporary hack to set widget to light theme as it is hardcoded into our user config on pandascore side
    urlObjectRef.current.searchParams.set('user', pandascoreUserName);
  } else {
    urlObjectRef.current.searchParams.delete('user');
  }

  if (isShowTabs) {
    urlObjectRef.current.searchParams.set('block', selectedTab);
    urlObjectRef.current.searchParams.set('full_height', 'true');
  }

  const handleSelectTab = useCallback(
    (selectedBlock: string) => {
      urlObjectRef.current.searchParams.set('block', selectedBlock);

      if (
        categoryId === SPORT_IDS.DOTA2 &&
        selectedBlock === PandascoreBlock.GENERAL_STATS
      ) {
        urlObjectRef.current.searchParams.set('scoreboard', 'detailed');
      }

      setSearch((searchParams) => {
        searchParams.set('tab', selectedBlock);
        return searchParams;
      });
    },
    [categoryId, setSearch]
  );

  return {
    isShowPandascoreTabs: isShowTabs,
    url: urlObjectRef.current.toString(),
    selectedTab,
    handleSelectTab
  };
};

export default usePandascore;
